import React, { lazy } from "react";
import { docLazyFn } from '@/router/untilFn'

// 沙盒-导航栏
import SandBox from '@/components/SandBox'

// UserManagment
import UserManagment from "@/views/UserManagement/Account"
import AppUser from "@/views/UserManagement/AppUser"
import Role from "@/views/UserManagement/Role"
import RoleManagement from '@/views/UserManagement/Role/component/RoleManagement'
import Menu from "@/views/UserManagement/Menu"

const userManagment = [
  {
    path: "/UserManagment",
    element: <SandBox />,
    children: [
      {
        path: "Account",
        element: docLazyFn(<UserManagment />),
      }, 
      {
        path: "Role",
        element: docLazyFn(<Role />),
      },
       {
        path: "AppUser",
        element: docLazyFn(<AppUser />),
      },
       {
        path: "Menu",
        element: docLazyFn(<Menu />),
      }
    ],
  },
  {
    path: "/UserManagment/RoleManagement",
    element: docLazyFn(<RoleManagement />),
  }
];

export default userManagment;
